import { useMemo } from 'react';
import { useQuery } from 'data-fetching-client';
import UISelect from 'UIComponents/input/UISelect';
import { GET_OBJECT_PROPERTIES_BY_GROUP } from 'automation-ui-references/object-type-properties/ObjectTypePropertyQueries';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import { flattenPropertyGroups, isVisible, convertProperyToOption, arePropertyTypesCopyCompatible } from 'automation-ui-formula-editor/fetch-object-panel/utils/propertyUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const EMPTY_PROPERTY_GROUPS = [];
export default function AddDataSourceMatchingEnrolledPropertySelect({
  flowObjectTypeId,
  dataSourceProperty,
  enrolledPropertyName,
  onEnrolledPropertyChange,
  readOnly
}) {
  var _enrolledPropertyData;
  const {
    data: enrolledPropertyData,
    loading: enrolledPropertiesLoading
  } = useQuery(GET_OBJECT_PROPERTIES_BY_GROUP, {
    variables: {
      objectTypeId: flowObjectTypeId
    }
  });
  const enrolledPropertiesByGroup = (_enrolledPropertyData = enrolledPropertyData === null || enrolledPropertyData === void 0 ? void 0 : enrolledPropertyData.automation_propertiesByGroup) !== null && _enrolledPropertyData !== void 0 ? _enrolledPropertyData : EMPTY_PROPERTY_GROUPS;
  const enrolledPropertyOptions = useMemo(() => flattenPropertyGroups(enrolledPropertiesByGroup).filter(isVisible).filter(property => dataSourceProperty && arePropertyTypesCopyCompatible(property, dataSourceProperty)).map(convertProperyToOption), [enrolledPropertiesByGroup, dataSourceProperty]);
  const handleChangeEnrolledProperty = event => {
    onEnrolledPropertyChange(event.target.value);
  };
  return /*#__PURE__*/_jsx(UISelect, {
    disabled: !dataSourceProperty || enrolledPropertiesLoading,
    isLoading: enrolledPropertiesLoading,
    onChange: handleChangeEnrolledProperty,
    options: enrolledPropertyOptions,
    value: enrolledPropertyName,
    readOnly: readOnly,
    placeholder: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.property-matching.enrolled-property-placeholder_cob",
      objectTypeId: flowObjectTypeId
    })
  });
}